import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { RenderFn } from 'src/types/widgets';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './RoiCalculator.widget.js';
import configuration from './data/index';
import Auto from './components/Auto';
import jsondata from './utils/json/staticdata.json';
import 'carbon-components/css/carbon-components.min.css';

const render: RenderFn = async function (instanceId, langCode, origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );

  if (!element || !locale) {
    return;
  }

  ReactDOM.render(
    <React.StrictMode>
      <IntlProvider locale={locale} messages={messages}>
        <Auto configuration={configuration} jsondata={jsondata} />
      </IntlProvider>
    </React.StrictMode>,
    element,
    () => cb(element),
  );
};

export default render;
